export enum AccountTransactionTypeEnum {
  Debit = 'debit',
  Credit = 'credit',
}
